import ScrollReveal from 'scrollreveal';

ScrollReveal().reveal( '.sr-left', { duration: 1500, origin: 'left', distance: '100px' } );
ScrollReveal().reveal( '.sr-right', { duration: 1500, origin: 'right', distance: '100px' } );
ScrollReveal().reveal( '.sr-bottom', { duration: 1500, origin: 'bottom', distance: '100px' } );
ScrollReveal().reveal( '.sr-top', { duration: 1500, origin: 'top', distance: '100px' } );
